import './index.scss';

function blockSetup() {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @since   1.0.0
	 *
	 * @param object $block The block jQuery element.
	 * @param object attributes The block attributes (only available when editing).
	 * @return  void
	 */

	const blockType = 'imado-works';
	const blockClass = `wp-block-${blockType}`;

	function initBlock(block) {
		// Initialize block functionality if needed
		// console.log('Works block initialized');
	}

	/**
	 * Initialize each block on page load (front end).
	 */
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll(`.${blockClass}`).forEach((block) => {
			initBlock(block);
		});
	});
}
blockSetup();
